<!-- [画面上部固定フローティングナビ] -->
<div class="l-top-float l-top-float--pc-has-border js-top-float-accordion seatmap-top-float">
  <div class="p-top-float-navi01">
    <div class="p-top-float-navi01__item js-top-float-accordion-item">
      <!--セグメント情報-->
      <asw-servicing-seatmap-segments
        [displayTargetSegment]="displayTargetSegment"
        [displayTargetSegmentId]="displayTargetSegmentId"
        [pnrInfo]="pnrInfo"
        [airlines]="airlines"
        (clickSegment)="clickSegment($event)"
      ></asw-servicing-seatmap-segments>
    </div>
    <div class="p-top-float-navi01__item js-top-float-accordion-item" *aswIfScreenSize="'SP'">
      <asw-servicing-seatmap-assignment-status
        [passengerIdList]="passengerIdList"
        [travelersMap]="travelersMap"
        [selectingPassengerId]="selectingPassengerId"
        [selectingSeatNumber]="selectingSeatNumber"
        [displayTargetSegmentId]="displayTargetSegmentId"
        [selectedSeatInfoList]="selectedSeatInfoList"
        [seatInformationMap]="seatInformationMap"
        [isChangeRestrictedAllSeat]="isChangeRestrictedAllSeat"
        (clickPassenger)="onClickPassenger($event)"
      ></asw-servicing-seatmap-assignment-status>
    </div>
  </div>
</div>

<div class="l-core-contents__inner l-core-contents__inner--bt-0 l-core-contents__inner--full l-wrap__inner">
  <!-- [コンテンツ領域−メイン] -->
  <div class="l-core-contents__main">
    <div class="l-seatmap-container">
      <div class="l-seatmap-container__body" *ngIf="isdisplayContent">
        <!--指定状況詳細（当該セグメント）-->
        <div class="l-seatmap-container__body-left">
          <asw-servicing-seatmap-assignment-status
            [passengerIdList]="passengerIdList"
            [travelersMap]="travelersMap"
            [selectingPassengerId]="selectingPassengerId"
            [selectingSeatNumber]="selectingSeatNumber"
            [displayTargetSegmentId]="displayTargetSegmentId"
            [selectedSeatInfoList]="selectedSeatInfoList"
            [seatInformationMap]="seatInformationMap"
            [isChangeRestrictedAllSeat]="isChangeRestrictedAllSeat"
            (clickPassenger)="onClickPassenger($event)"
          ></asw-servicing-seatmap-assignment-status>
          <!-- チャイルドシート選択モーダル表示 -->
          <asw-servicing-seatmap-open-child-seat-selection-modal-button
            [travelersMap]="travelersMap"
            [isInformative]="false"
            [selectingPassengerId]="selectingPassengerId"
            [numberOfChildSeats]="numberOfChildSeats"
            (clickBringChildSeat)="onClickBringChildSeat()"
          ></asw-servicing-seatmap-open-child-seat-selection-modal-button>
          <ng-container *aswIfScreenSize="['TAB', 'PC']"
            ><asw-servicing-seatmap-seat-products
              *ngIf="normalSeatImageExist"
              [displayTargetSegment]="displayTargetSegment"
            ></asw-servicing-seatmap-seat-products
          ></ng-container>
        </div>

        <!-- シートマップ -->
        <div class="l-seatmap-container__body-seatmap">
          <asw-servicing-seatmap-seatmap
            [isExistUpper]="isExistUpper"
            [isExistMain]="isExistMain"
            [passengerIdList]="passengerIdList"
            [passengers]="travelersMap"
            [displayTargetSegment]="displayTargetSegment"
            [seatInformationMap]="seatInformationMap"
            [selectingPassengerId]="selectingPassengerId"
            [selectedSeatInfoList]="selectedSeatInfoList"
            [displayTargetSegmentId]="displayTargetSegmentId"
            [cabinClasses]="cabinClasses"
            [bookingClass]=""
            [initialDeckType]="initialDeckType"
            [isChangeRestrictedAllSeat]="isChangeRestrictedAllSeat"
            (clickSeat)="onClickSeat($event)"
          ></asw-servicing-seatmap-seatmap>
        </div>
        <!--凡例-->
        <div class="l-seatmap-container__body-right">
          <!-- 凡例 -->
          <asw-servicing-seatmap-legends
            [cabin]="displayTargetSegment?.cabin || ''"
            [isContainedRearFacingSeat]="seatmaps?.isCotaninedRearFacingSeat || false"
            [isContainedPaidAsrSeat]="seatmaps?.isContainedChargeableAsrSeat || false"
            [isContainedCouchSeat]="seatmaps?.isContainedCouchSeat || false"
          >
          </asw-servicing-seatmap-legends>
        </div>
      </div>
    </div>
  </div>
  <!-- //[コンテンツ領域−サブ] -->
</div>
<!-- [コンテンツ領域 画面下部固定フローティングナビ] -->
<asw-servicing-seatmap-floating-navi
  *ngIf="isdisplayContent"
  [allSegmentInfo]="allSegmentInfo"
  [travelersMap]="travelersMap"
  [selectingPassengerId]="selectingPassengerId"
  [isInformative]="false"
  [normalSeatImageExist]="normalSeatImageExist"
  [displayTargetSegmentId]="displayTargetSegmentId"
  [numberOfChildSeats]="numberOfChildSeats"
  (clickBringChildSeat)="onClickBringChildSeat()"
  (clickLayoutDetail)="onClickLayoutDetail()"
  (clickSeatType)="onClickSeatType()"
  (clickLegend)="onClickLegend()"
>
</asw-servicing-seatmap-floating-navi>
<!-- //[コンテンツ領域 画面下部固定フローティングナビ] -->
<!--フッターエリア-->
<asw-seatmap-footer-area
  (screenReload)="nextFlight.emit()"
  (showNextSegment)="showNextSegment()"
></asw-seatmap-footer-area>
